import { DialogData } from './dialog.model';
import { Observable } from 'rxjs';
import { EInfoSelectItemType } from './select.model';
import { ButtonComponent } from '../../shared/ui/button/button.component';

export enum ButtonColor {
  ORANGE = 'orange',
  GREEN = 'green',
  BLUE = 'blue',
  RED = 'red',
  WHITE = 'white',
  CYAN = 'cyan',
}

export enum ButtonSize {
  SMALL = 'small',
  NORMAL = 'normal',
  BIG = 'big',
}

export interface Button {
  route?: any;
  queryParams?: { [key: string]: any };
  onClick?: (element?: any, button?: ButtonComponent) => void;
  text: string;
  color: ButtonColor;
  size?: ButtonSize;
  buttonDisabled?: (data: any) => boolean;
  style?: 'outline' | 'filled' | 'rounded';
  loadingObservable?: Observable<any>;
  observeApi?: boolean;
}

export enum EButtonSelectItemType {
  TYPE_LINK = 'link',
  TYPE_NORMAL = 'normal',
}

export interface IButtonSelectItem {
  label: string;
  type?: EButtonSelectItemType | EInfoSelectItemType;
  value?: any;
  popoverText?: string;
  onClick?: () => void;
  dialogContent?: DialogData;
  children?: IButtonSelectItem[];
  tag?: string;
}
